import { GetEpAgreementWallContextQuery } from '../../../graphql/queries/getEpAgreementWallContext.gql';

export const getIsAgreementDone = (
  moduleData: GetEpAgreementWallContextQuery,
) => {
  return (
    moduleData.viewer.outstandingAgreements.length === 0 ||
    // @ts-expect-error Object is possibly 'undefined'.
    moduleData.viewer.outstandingAgreements[0].status === 'COMPLETE'
  );
};
